
import { getMenu } from "@/utils/getSeoMenu";
import React from "react";
import ProductListing from "../components/ProductListingComp";

//OS-3066 : added to check if css issue gets fixed
export const getStaticProps = async () => {
  return {
    props: { menuElement : await getMenu("/") },
    revalidate: 60,
  };
};

const Designers = () => {
    return (
      <ProductListing/>
    );

};



export default Designers;